import { motion } from "framer-motion";

const AboutSection = () => {
  return (
    <section className="py-20 -mt-14 bg-brandLight" id="about">
      <div className="max-w-5xl mx-auto px-6">
      <div className="hidden md:block">
        <h3 className="text-3xl font-bold text-center mb-12">Kilka słów o mnie</h3>
        </div>

        <motion.div
          className="flex flex-col md:flex-row items-center gap-10"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.3, ease: "easeOut" }}
          viewport={{ once: true }}
        >
          {/* Zdjęcie */}
          <div className="flex-shrink-0">
            <img
              src="/images/bartekmain.jpg"
              alt="Bartosz Kostuj"
              className="w-64 h-64 rounded-full object-cover shadow-lg mx-auto md:mx-0"
            />
          </div>

          {/* Tekst */}
          <div className="text-brandDark text-lg leading-relaxed">
            <h4 className="text-2xl font-semibold mb-2">Bartosz Kostuj</h4>
            <p className="text-brandGreen mb-4">Trener Personalny</p>
            <p>
              Cześć, mam na imię Bartek, trenuję od 10 lat, a od kilku lat jestem zawodnikiem trójboju siłowego.
              Chętnie pomogę w twoich treningach, bez względu na to, czy twoim celem jest zgubienie paru kilogramów,
              poprawienie kondycji fizycznej czy zbudowanie siły i masy mięśniowej.
              <br /><br />
              Pozdrawiam i zapraszam do kontaktu! 😊
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default AboutSection;
